<template>
  <ul class="tabs-simple">
    <li
      v-for="(item, index) in tabs"
      :key="index"
      :class="{active: item.id == curTab}"
      @click="curTab = item.id"
    >{{item.label}}</li>
  </ul>
</template>

<script>
export default {
  name: "TabsSimple",
  props: {
    value: {
      default: ""
    },
    // 格式 [{id: 0, label: 'lalala'}]
    tabs: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      curTab: ""
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.curTab = val;
      }
    },
    curTab(val) {
      this.$emit("update:value", val);
      this.$emit("on-change", val);
    }
  },
  created() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.tabs-simple {
  li {
    display: inline-block;
    font-size: 16px;
    color: #999;
    padding: 0 16px;
    position: relative;
    cursor: pointer;

    &.active {
      color: $primary-color;
      font-weight: 500;
    }

    &:first-of-type {
      padding-left: 0;
    }

    &:last-of-type {
      padding-right: 0;
    }

    &::after {
      content: "";
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      height: 17px;
      width: 1px;
      background: #d9d9d9;
    }

    &:last-of-type::after {
      display: none;
    }
  }
}
</style>